import * as React from 'react';
import { useEditorContext } from '../editor_context';
import {
   BlockquoteButton,
   BulletListButton,
   CodeBlockButton,
   IndentButton,
   OrderedListButton,
   UnindentButton,
} from './buttons';
import { MenuSeparator } from './MenuSeparator';

const nodeToButtons = {
   codeBlock: [<CodeBlockButton key="codeBlock" />],
   blockquote: [<BlockquoteButton key="blockquote" />],
   bulletList: [<BulletListButton key="bulletList" />],
   orderedList: [<OrderedListButton key="orderedList" />],
   listItem: [<UnindentButton key="unindentListItem" />, <IndentButton key="indentListItem" />],
};

type Node = keyof typeof nodeToButtons;

interface NodeMenuItemProps {
   node: Node;
}

const NodeMenuItem = (props: NodeMenuItemProps) => {
   return <>{nodeToButtons[props.node]}</>;
};

interface NodeMenuProps {
   preSeparator?: boolean;
   postSeparator?: boolean;
}

export const NodeMenu = (props: NodeMenuProps) => {
   const { editor } = useEditorContext();

   const buttons = (Object.keys(nodeToButtons) as Node[])
      .filter(node => node in editor.schema.nodes)
      .map(node => <NodeMenuItem node={node} key={node} />);

   if (!buttons.length) {
      return null;
   }

   return (
      <>
         {props.preSeparator ? <MenuSeparator /> : null}
         {buttons}
         {props.postSeparator ? <MenuSeparator /> : null}
      </>
   );
};
